<template>
  <div class="modal fade" id="app_info_modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" style="color: #9b9b9b;" id="exampleModalLongTitle">应用更新</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <el-form size="mini" ref="form">
            <el-form-item label="更新IPA" :http-request="updateAutoSignApp">
              <!-- <input style="float:left;margin-left:2em" id="file" @change="fileChange" type="file"> -->
              <el-upload :action="uploadUrl()" class="upload-demo" ref="upload" :data="requestParams()" drag
                :multiple="false" :auto-upload="false" :limit="1" :on-change="fileChange" :on-success="uploadSuccess">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div style="color:#579FF8;font-weight:bold" class="el-upload__tip" slot="tip">只能上传ipa文件</div>
              </el-upload>
            </el-form-item>
            <el-form-item label="自动解锁">
              <el-switch style="float:left;margin-left:2em" v-model="unlock" @change="clickUnlock"></el-switch>
            </el-form-item>
            <el-form-item v-if="unlock" label="有效动态库">
              <textarea class="form-control" v-model="excludeDylibNames" placeholder="非必填项 请输入应用包内依赖的动态库名称，如有多个按空格键分隔"
                cols="50" rows="3"></textarea>
            </el-form-item>
          </el-form>

          <div v-if="startUpload">
            <p></p>
            <div class="progress">
              <div class="progress-bar progress-bar-striped bg-success" role="progressbar" aria-valuenow="25"
                aria-valuemin="0" aria-valuemax="100" :style="'width:'+progress">{{progress}}</div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button :disabled="uploadButtonClick" style="width: 30em;height: 3em;" type="button" class="btn btn-primary"
            @click="updateAutoSignApp">立即上传</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var self;
export default {
  props: ["autoSignAppId"],
  data() {
    return {
      uploadButtonClick: true,
      startUpload: false,
      progress: "",
      unlock: true,
      excludeDylibNames: "",
      ipaFile: null
    };
  },
  mounted() {
    self = this;
    console.log(this.autoSignAppId);
    this.$nextTick(() => {
      $("#app_info_modal").modal("show");
      $("#app_info_modal").on("hidden.bs.modal", function(e) {
        console.log("模态框消失");
        self.$emit("showModal", false);
      });
    });
  },
  methods: {
    uploadUrl: function() {
      var url = "https://autosign.35ff.vip/auth/auto/sign/task/update";
      url = this._Global.HTTP_SERVER + "/auth/auto/sign/task/update";
      return url;
    },
    requestParams: function() {
      return {
        autoSignAppId: this.autoSignAppId,
        authToken: this.getToken(),
        excludeDylibNames: this.excludeDylibNames
      };
    },
    fileChange: function(file, fileList) {
      var fileName = file.name;
      if (fileName.substr(fileName.lastIndexOf(".")) != ".ipa") {
        this.errToastr("请选择ipa文件");
        this.uploadButtonClick = true;
        return;
      }
      this.uploadButtonClick = false;
    },
    readPkgInfo: function(f, callBack) {
      var zipJs = new JSZip();
      zipJs.loadAsync(f).then(function(zip) {
        zip.forEach(function(relativePath, file) {
          var length = relativePath.length;
          if (relativePath.substr(length - 15, length) == ".app/Info.plist") {
            self.readPlist(file, function(packageInfo) {
              callBack(packageInfo);
            });
          }
        });
        console.log(file);
      });
    },
    updateAutoSignApp: function() {
      this.$refs.upload.submit();
    },
    clickUnlock: function() {
      this.excludeDylibNames = "";
    },
    uploadSuccess: function(response, file, fileList) {
      self.respDataHandle(response, function(data) {
        $("#app_info_modal").modal("hide");
      });
    }
  }
};
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/AutoSignAppUpdateWindow.vue